import styled, { css } from 'styled-components';
import { transparentize } from 'polished';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    margin-left: ${theme.spacings[20]};
    position: relative;

    display: inline-flex;

    .languageLabel {
    }

    .languageFlag {
      display: none;
    }

    @media (max-width: 640px) {
      .languageFlag {
        display: block;
      }
      .languageLabel {
        display: none;
      }
    }

    .flagOptionBlock {
      padding: ${theme.spacings[8]};

      display: inline-flex;

      border: 0;
      border-radius: ${theme.radius.full};

      background-color: ${transparentize(0.7, theme.colors.gray600)};

      transition: all 0.2s;
      cursor: pointer;

      &:hover {
        // background-color: ${transparentize(0.9, theme.colors.indigo800)};
      }

      img {
        width: 2.4rem;
      }
    }
  `}
`;

export const LanguageOptions = styled.div`
  ${({ theme }) => css`
    min-width: 20rem;
    position: absolute;
    top: 125%;
    right: 0;

    z-index: 7;

    box-shadow: 0 0.4rem 1.2rem ${transparentize(0.5, theme.colors.black)};

    .option {
      width: 100%;
      padding: ${theme.spacings[12]};

      display: flex;
      align-items: center;

      background-color: ${theme.colors.white};

      transition: all 0.2s;
      cursor: pointer;

      &:hover {
        background-color: ${theme.colors.gray200};
      }

      img {
        width: 2rem;
        margin-right: ${theme.spacings[8]};
      }
    }
  `}
`;

export const Modal = styled.div`
  ${({ }) => css`
    padding: 15px;
    padding-bottom: 0px;
    max-width: 70rem;

    .buttons {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: center;

      gap: 10px;
    }
  `}
`;
